import React from 'react';
import { motion } from 'framer-motion';
export function Pricing() {
  return <section id="compra" className="flex flex-col gap-8 py-16 scroll-mt-8" data-id="element-92">
      <h3 className="font-serif text-4xl font-bold text-[#0F4C3A] text-center" data-id="element-93">
        Tu inversión
      </h3>

      <div className="flex flex-col bg-[#0F4C3A] text-white p-8 md:p-10 rounded-3xl shadow-2xl border-4 border-[#1B5E4F] gap-8 text-center" data-id="element-94">
        <div className="flex flex-col gap-3 text-lg font-medium text-[#FBF8F3]" data-id="element-95">
          <p data-id="element-96">6 módulos clínicos · 540 fichas</p>
          <p data-id="element-97">8 bonos incluidos</p>
          <p data-id="element-98">3 rangos etarios cubiertos</p>
        </div>

        <div className="flex flex-col gap-2 border-t border-white/15 pt-6 text-[#FBF8F3]/90 text-lg" data-id="element-99">
          <p data-id="element-100">Todo en un solo sistema.</p>
          <p data-id="element-101">Para todos tus pacientes.</p>
          <p className="font-bold text-[#FBF8F3]" data-id="element-102">De por vida.</p>
        </div>

        <div className="flex flex-col gap-2 bg-white/10 py-6 rounded-2xl" data-id="element-103">
          <p className="text-lg font-medium" data-id="element-104">Pago único de</p>
          <p className="font-serif text-5xl md:text-6xl font-bold text-[#FBF8F3]" data-id="element-105">
            $19.990 ARS
          </p>
          <p className="text-sm font-medium text-[#FBF8F3]/80 mt-1" data-id="element-106">
            Acceso inmediato · Descarga en PDF
          </p>
        </div>

        <div className="flex flex-col gap-4" data-id="element-107">
          <motion.a href="https://intervencioncheck.librosdigitales.pro/cart/46887436353675:1" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex flex-col items-center justify-center w-full bg-[#D97757] hover:bg-[#c26547] text-white font-bold text-xl py-6 px-6 rounded-xl shadow-xl transition-colors text-center" data-id="element-108">
            QUIERO EL SISTEMA AHORA →
          </motion.a>

          <img src="https://cdn.magicpatterns.com/uploads/cVXWqaJjdh9gCnJcqWN39J/imagen.png" alt="Pago seguro con Mercado Pago — Aceptamos Visa, Mastercard, American Express, Diners Club" className="w-full h-[76px] object-contain bg-white rounded-xl" data-id="element-109" />

          <p className="text-sm text-[#FBF8F3]/70 flex flex-col items-center gap-2 mt-2" data-id="element-110">
            <span data-id="element-111">🔒 Pago seguro · Garantía de 7 días</span>
          </p>
        </div>
      </div>
    </section>;
}